import { Checkbox } from "@clarityos/ui";
import type { CheckboxProps } from "@clarityos/ui";
import { twMerge } from "tailwind-merge";

type CheckboxBlockProps = Omit<CheckboxProps, "className">;

export function CheckboxBlock({ checked, ...props }: CheckboxBlockProps) {
  return (
    <div
      className={twMerge(
        "rounded-12 border px-4 py-3.5 transition-all duration-200",
        checked
          ? "border-support-typical-neutral bg-support-typical-neutral"
          : "border-stroke-default bg-surface-muted",
      )}
    >
      <Checkbox checked={checked} {...props} />
    </div>
  );
}
